export default "__VITE_ASSET__eIPGjADC__"